import api from "./api";

export const getCredential = async(mark?: string, company?: string) => {
    const params = new URLSearchParams();
    if (mark) params.append('mark', mark);
    if (company) params.append('company', company);
    const query = params.toString();
    const response = await api.get(`credential/listAll${query ? `?${query}` : ''}`);
    return response.data;
};

export const getCredentialOne = async(credential: string) => {
    const response = await api.get(`credential/${credential}`);
    return response.data;
};

export const startSyncPlants = async(id: string) => {
    const response = await api.post(`credential/startSyncPlants/${id}`);
    return response.data;
};

export const updateCredentialVerificad = async(data: any, id: string) => {
    const response = await api.put(`credential/updateVerificad/${id}`, data);
    return response.data;
};

export const postCredentialVerificad = async(data: any) => {
    const response = await api.post(`credential/createVerificad`, data);
    return response.data;
};

export const deleteCredential = async(id: any) => {
    const response = await api.delete(`credential/${id}`,);
    return response.data;
};